import { render, staticRenderFns } from "./compatibility.vue?vue&type=template&id=b248a99a&scoped=true&"
import script from "./compatibility.vue?vue&type=script&lang=js&"
export * from "./compatibility.vue?vue&type=script&lang=js&"
import style0 from "./compatibility.vue?vue&type=style&index=0&id=b248a99a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b248a99a",
  null
  
)

export default component.exports